import React, { FC } from 'react';
import {
    Control,
    FormCounter,
    FormElement,
    FormHeader,
    FormLabel,
    FormOptionalLabel,
    Textarea,
} from '@fiverr-private/forms';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { REQUEST_TEXT_CONTROL_TRANSLATION_KEY } from '../constants';
import { RequestTextControlProps } from './types';

export const RequestTextControl: FC<RequestTextControlProps> = ({ requestText, onChange }) => {
    const placeholderCopy = translate(`${REQUEST_TEXT_CONTROL_TRANSLATION_KEY}.placeholder`);

    return (
        <Control maxLength={500}>
            <FormHeader>
                <FormLabel>
                    <Text as="span" fontWeight="bold">
                        <I18n k={`${REQUEST_TEXT_CONTROL_TRANSLATION_KEY}.label`} />
                    </Text>
                </FormLabel>
                <FormOptionalLabel />
            </FormHeader>
            <FormElement>
                <Textarea rows={5} placeholder={placeholderCopy} value={requestText} onChange={onChange} />
            </FormElement>
            <FormCounter value={requestText} />
        </Control>
    );
};
